import { render, staticRenderFns } from "./ExceptionPage.vue?vue&type=template&id=4c66412c&"
import script from "./ExceptionPage.vue?vue&type=script&lang=js&"
export * from "./ExceptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports